import { z } from 'zod';

export const kratosIdentitySchema = z.object({
  id: z.string(),
  traits: z.object({
    email: z.string(),
    picture: z.string().optional(),
  }),
  verifiable_addresses: z
    .array(
      z.object({
        value: z.string(),
        verified: z.boolean(),
        via: z.string().optional(),
        status: z.string().optional(),
      }),
    )
    .optional(),
  metadata_public: z
    .object({
      provider_twitch: z
        .object({
          user_id: z.string(),
          channel: z.string().optional(),
        })
        .optional(),
      provider_youtube: z
        .object({
          user_id: z.string(),
          channel: z.string().optional(),
        })
        .optional(),
    })
    .nullable(),
});

export type KratosIdentity = z.infer<typeof kratosIdentitySchema>;
